"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getForegroundColor = exports.getBorderColor = exports.WHCM_BACKGROUND_COLOR = exports.DEFAULT_THRESHOLD_COLOR_KEY = exports.BACKGROUND_COLOR_KEY = void 0;

var _isHighContrast = require("../utils/isHighContrast");

var _interfaces = require("./interfaces");

var BACKGROUND_COLOR_KEY = 'neutral0';
exports.BACKGROUND_COLOR_KEY = BACKGROUND_COLOR_KEY;
var WHCM_BACKGROUND_COLOR = 'canvasText';
exports.WHCM_BACKGROUND_COLOR = WHCM_BACKGROUND_COLOR;
var DEFAULT_THRESHOLD_COLOR_KEY = 'neutral50';
exports.DEFAULT_THRESHOLD_COLOR_KEY = DEFAULT_THRESHOLD_COLOR_KEY;

var getForegroundColor = function getForegroundColor(status, selectors) {
  if (_isHighContrast.isInHighContrast) {
    return WHCM_BACKGROUND_COLOR;
  }

  switch (status) {
    case _interfaces.ProgressBarStatus.Warning:
      return selectors.color('yellow60');

    case _interfaces.ProgressBarStatus.Negative:
      return selectors.color('red50');

    case _interfaces.ProgressBarStatus.Positive:
      return selectors.color('green50');

    case _interfaces.ProgressBarStatus.Loading:
      return selectors.color('primary50');

    default:
      return selectors.color('neutral50');
  }
};

exports.getForegroundColor = getForegroundColor;

var getBorderColor = function getBorderColor(status, selectors) {
  switch (status) {
    case _interfaces.ProgressBarStatus.Warning:
      return selectors.color('yellow80');

    case _interfaces.ProgressBarStatus.Negative:
      return selectors.color('red80');

    case _interfaces.ProgressBarStatus.Positive:
      return selectors.color('green80');

    case _interfaces.ProgressBarStatus.Loading:
      return selectors.color('primary80');

    default:
      return selectors.color('neutral80');
  }
};

exports.getBorderColor = getBorderColor;